import { render, staticRenderFns } from "./audience-login.vue?vue&type=template&id=2b331ee9&scoped=true&"
import script from "./audience-login.vue?vue&type=script&lang=js&"
export * from "./audience-login.vue?vue&type=script&lang=js&"
import style0 from "./audience-login.vue?vue&type=style&index=0&id=2b331ee9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b331ee9",
  null
  
)

export default component.exports